var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 213,
    height: 64,
    viewBox: "0 0 213 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 213,
    height: 64,
    fill: "#000",
    rx: 10
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFF",
    fontFamily: "Helvetica",
    fontSize: 15,
    letterSpacing: 1.2
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 68,
    y: 23
  }, "Download on the")), /*#__PURE__*/React.createElement("text", {
    fill: "#FFF",
    fontFamily: "Helvetica",
    fontSize: 29
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 68,
    y: 51
  }, "App Store")), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M48.16 47.705c-1.756 2.554-3.57 5.093-6.436 5.147-2.82.053-3.725-1.664-6.944-1.664-3.221 0-4.23 1.61-6.892 1.717-2.767.103-4.87-2.76-6.64-5.303-3.614-5.2-6.373-14.703-2.663-21.116 1.838-3.185 5.13-5.2 8.697-5.253 2.717-.05 5.284 1.824 6.943 1.824 1.663 0 4.778-2.25 8.053-1.92 1.371.057 5.219.55 7.69 4.15-.195.128-4.593 2.675-4.54 7.981.055 6.34 5.58 8.446 5.644 8.475-.05.149-.883 3.008-2.913 5.962zm-12.033-33.53c1.516-1.77 4.08-3.087 6.194-3.175.27 2.458-.723 4.92-2.19 6.693-1.47 1.77-3.876 3.15-6.237 2.966-.321-2.405.869-4.913 2.233-6.485z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleStore);
export default __webpack_public_path__ + "static/media/apple-store.43f8ca7d4a3d99453b93d51338840835.svg";
export { ForwardRef as ReactComponent };